import React, { ReactNode } from 'react';
import { NotificationProvider } from '@/contexts/NotificationContext';

interface OrderNotificationProviderProps {
  children: ReactNode;
  orderId?: number;
}

/**
 * Wrapper component for order-specific pages that need WebSocket notifications
 * for anonymous orders. This provides a nested NotificationProvider with the orderId.
 * 
 * For authenticated users, the app-level NotificationProvider handles notifications.
 * For anonymous orders, use this component to wrap the page content.
 */
export const OrderNotificationProvider: React.FC<OrderNotificationProviderProps> = ({ 
  children, 
  orderId 
}) => {
  if (!orderId) {
    // If no orderId, just render children (authenticated users use app-level provider)
    return <>{children}</>;
  }

  return (
    <NotificationProvider orderId={orderId}>
      {children}
    </NotificationProvider>
  );
};

export default OrderNotificationProvider;
